import { SneakerIcon, TShirtIcon } from '@phosphor-icons/react'

import { Alert, SplitButton } from '@reveni-io/reveni-ui'

import { miscPreviewSections } from '../constants'
import EmailPostcodePreview from './EmailPostcodePreview/EmailPostcodePreview'
import MiscCardPreview from './MiscCardPreview/MiscCardPreview'
import OrderNumberPreview from './OrderNumberPreview/OrderNumberPreview'
import { getMiscLabel } from './helpers'

const MiscPreview = ({ activeMiscType, customCopies, lang, previewUrl, isCustomCopyActive }) => {
  const getLabel = key => getMiscLabel(key, customCopies, lang)

  if (activeMiscType === miscPreviewSections.orderNumber) {
    return (
      <OrderNumberPreview
        previewUrl={previewUrl}
        customCopies={customCopies}
        lang={lang}
        isCustomCopyActive={isCustomCopyActive}
      />
    )
  }

  if (activeMiscType === miscPreviewSections.emailPostcode) {
    return (
      <EmailPostcodePreview
        previewUrl={previewUrl}
        customCopies={customCopies}
        lang={lang}
        isCustomCopyActive={isCustomCopyActive}
      />
    )
  }

  if (activeMiscType === miscPreviewSections.variants) {
    return (
      <MiscCardPreview>
        <SplitButton
          label={getLabel(miscPreviewSections.variants)}
          icon={
            <>
              <TShirtIcon size={40} color="white" />
              <TShirtIcon size={28} color="white" />
            </>
          }
        />
      </MiscCardPreview>
    )
  }

  if (activeMiscType === miscPreviewSections.otherProducts) {
    return (
      <MiscCardPreview>
        <SplitButton
          label={getLabel(miscPreviewSections.otherProducts)}
          icon={
            <>
              <TShirtIcon size={40} color="white" />
              <SneakerIcon size={28} color="white" />
            </>
          }
        />
      </MiscCardPreview>
    )
  }

  if (activeMiscType === miscPreviewSections.outOfStock) {
    return (
      <MiscCardPreview>
        <Alert type="error">{getLabel(miscPreviewSections.outOfStock)}</Alert>
      </MiscCardPreview>
    )
  }

  return null
}

export default MiscPreview
